import api from './api';
import { AuthResponse, LoginRequest, RegisterRequest, User } from '../types/auth.types';

export const authService = {
  async login(credentials: LoginRequest): Promise<User> {
    const response = await api.post<AuthResponse>('/api/auth/login', credentials);
    return response.data.user;
  },

  async register(data: RegisterRequest): Promise<User> {
    const response = await api.post<AuthResponse>('/api/auth/register', data);
    return response.data.user;
  },

  async logout(): Promise<void> {
    await api.post('/api/auth/logout');
  },

  async getCurrentUser(): Promise<User> {
    const response = await api.get<{ user: User }>('/api/auth/me');
    return response.data.user;
  },

  async forgotPassword(email: string): Promise<void> {
    await api.post('/api/auth/forgot-password', { email });
  },

  async resetPassword(token: string, password: string): Promise<void> {
    await api.post('/api/auth/reset-password', { token, password });
  },

  async deleteAccount(): Promise<void> {
    await api.delete('/api/auth/account');
  },
};
